module.exports = require("ember-intl/services/intl");